import { axiosCompanyPortalInstance } from ".";

/** GET /api/company_portal/v1/dashboard/overview (PROLINE-3755) — approved company owner only. */
const getCompanyPortalDashboardOverview = () =>
  axiosCompanyPortalInstance.get("/dashboard/overview");

/**
 * GET /api/company_portal/v1/dashboard/events_overview (PROLINE-3841) — the
 * company's events with per-event card figures. `status=ongoing` + `page=-1`
 * feeds the Ongoing Events cards; no date filter there, since an event that
 * launched months ago can still be running.
 */
const getCompanyPortalEventsOverview = (params = {}) =>
  axiosCompanyPortalInstance.get("/dashboard/events_overview", { params });

/**
 * GET /api/company_portal/v1/dashboard/client_satisfaction (PROLINE-3826) —
 * one card per client who submitted at least one satisfaction survey.
 */
const getCompanyPortalClientSatisfaction = (params = {}) =>
  axiosCompanyPortalInstance.get("/dashboard/client_satisfaction", { params });

/**
 * GET /api/company_portal/v1/activity_logs (PROLINE-3925) — the logged-in
 * company's activity log, newest first (company taken from the token).
 */
const getCompanyPortalActivityLogs = (params = {}) =>
  axiosCompanyPortalInstance.get("/activity_logs", { params });

export {
  getCompanyPortalDashboardOverview,
  getCompanyPortalEventsOverview,
  getCompanyPortalClientSatisfaction,
  getCompanyPortalActivityLogs,
};
